module.exports = __webpack_public_path__ + "img/gallery-wedding-cover.d794c53b.png";